import React, { useState } from "react";
import "../styles/GrievancePage.css";
import GrievanceImg from "../assets/photos/grievance.png";

export default function GrievancePage(){

const [activeBranch,setActiveBranch]=useState(null);

const toggleBranch=(index)=>{
setActiveBranch(activeBranch===index ? null : index);
};

const branches=[

{
name:"Chirabazar",
manager:"Mr. Sunil Bachhav",
phone:"022-22054671 / 72"
},

{
name:"Vithalwadi",
manager:"Mr. Rajendra J. Mangrule",
phone:"022-22425589"
},

{
name:"Lalbaug",
manager:"Mr. Mayuresh Akerkar",
phone:"022-24703583 / 6404"
},

{
name:"Kandivali",
manager:"Mr. Sameer Sakpal (Officer)",
phone:"022-28692529 / 28685099"
},

{
name:"Satara",
manager:"Mr. Shrikant R. Chavan (Officer)",
phone:"02162-232105 / 106"
},

{
name:"Kamothe",
manager:"Mr. Nivas B. Matekar",
phone:"022-27431588 / 27434187"
},

{
name:"Bhiwandi",
manager:"Mr. Mahadeo B. Khopade",
phone:"02522-278882 / 02522-278833"
},

{
name:"Dombivali",
manager:"Mr. Tanaji D. Aute",
phone:"0251-2439896"
}

];

return(

<div className="grievancepage-container">

{/* HERO */}

<section className="grievancepage-hero">

<h1>Grievance Redressal</h1>

<p>
Customer Complaint Resolution System
</p>

</section>



{/* INTRO SECTION WITH IMAGE */}

<section className="grievancepage-intro">

<div className="grievancepage-intro-grid">

<div className="grievancepage-intro-text">

<p>
Customers are informed that The Sahyadri Sahakari Bank Ltd.
has established a Customer Grievance Resolution System
and protocols to ensure swift resolution of all customer complaints,
including those related to outsourced activities and services
provided by vendors appointed by the Bank.
</p>

<p>
Customers are encouraged to first contact the Branch Manager
for quick resolution of complaints.
</p>

</div>

<div className="grievancepage-intro-image">

<img src={GrievanceImg} alt="Customer Support"/>

</div>

</div>

</section>



{/* RESOLUTION STEPS */}

<section className="grievancepage-steps">

<h2>Complaint Resolution Process</h2>

<div className="grievancepage-step-grid">

<div className="grievancepage-step-card">
<h3>1</h3>
<p>Branch Manager</p>
<span>Complaint book available at branch</span>
</div>

<div className="grievancepage-step-card">
<h3>2</h3>
<p>Divisional Manager</p>
<span>If not resolved within 5 working days</span>
</div>

<div className="grievancepage-step-card">
<h3>3</h3>
<p>AGM / DGM Level</p>
<span>Final escalation level</span>
</div>

</div>

</section>



{/* BRANCH DIRECTORY */}

<section className="grievancepage-branches">

<h2>Branch Grievance Contacts</h2>

<p className="grievancepage-branch-note">
Customers should first approach the Branch Manager
for resolution of complaints.
</p>

<div className="grievancepage-branch-list">

{branches.map((b,index)=>(

<div key={index} className="grievancepage-branch-item">

<div
className="grievancepage-branch-header"
onClick={()=>toggleBranch(index)}
>

<span>{b.name} Branch</span>

<span className="grievancepage-arrow">
{activeBranch===index ? "−" : "+"}
</span>

</div>

{activeBranch===index && (

<div className="grievancepage-branch-details">

<p><strong>Branch Manager:</strong> {b.manager}</p>

<p><strong>Telephone:</strong> {b.phone}</p>

</div>

)}

</div>

))}

</div>

</section>



{/* ATM COMPLAINT */}

<section className="grievancepage-atm">

<h2>ATM Complaints / Grievances</h2>

<p>
For ATM related complaints or grievance redressal,
please contact the bank support system.
</p>

<a href="/atm-complaint" className="grievancepage-btn">
Click Here for ATM Complaint System
</a>

</section>



{/* AADHAAR GRIEVANCE */}

<section className="grievancepage-aadhaar">

<h2>Aadhaar Grievance</h2>

<p>
For Aadhaar related queries or complaints,
please visit the official UIDAI grievance portal.
</p>

<a
href="https://uidai.gov.in/en/contact-support/grievance-redressal.html"
target="_blank"
rel="noreferrer"
className="grievancepage-btn"
>

Visit UIDAI Portal

</a>

</section>



{/* IMPORTANT NOTICE */}

<section className="grievancepage-notice">

<p>

If a complaint is lodged with the Branch Head,
it will be addressed and resolved within a maximum
of <strong>5 working days</strong> from the date of receipt.

If no response is received within 5 days,
the complaint may be escalated to the Divisional Manager,
and thereafter to AGM / DGM level.

</p>

</section>



</div>

);

}
